/**
 * @module features/perf/perfSearch
 *
 * URL search state of `/performance`: status and verdict filters of the ad hoc runs table.
 */
import { PerfRunStatusSchema, PerfVerdictSchema, type PerfRunStatus, type PerfVerdict } from '@chatsdet/types/perf';

export const PERF_STATUSES = PerfRunStatusSchema.options;
export const PERF_VERDICTS = PerfVerdictSchema.options;

export type PerfSearch = { status?: PerfRunStatus; verdict?: PerfVerdict };

export const parsePerfStatus = (value: string | undefined) => PERF_STATUSES.find((s) => s === value);
export const parsePerfVerdict = (value: string | undefined) => PERF_VERDICTS.find((v) => v === value);
